import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RegisterModal from "./RegisterModal";
import LoginModal from "./LoginModal";
import { FaRegCircleUser } from "react-icons/fa6";
import { RiMenu3Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import ProfileMenu from "./ProfileMenu";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isCompaniesPage = location.pathname.includes("/companies");
  const [searchQuery, setSearchQuery] = useState("");
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [plans, setPlans] = useState(null);
  const profileMenuRef = useRef(null);
  const profileButtonRef = useRef(null);

  useEffect(() => {
    // Check if the user is logged in by checking localStorage
    const loggedIn = localStorage.getItem("isLogin") === "true";
    const plan = sessionStorage.getItem("plans");
    setPlans(plan);
    setIsLogin(loggedIn);

    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target) &&
        !profileButtonRef.current.contains(event.target)
      ) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    console.log("Searching for:", searchQuery);
  };

  const openRegisterModal = () => {
    setIsRegisterModalOpen(true);
  };

  const closeRegisterModal = () => {
    setIsRegisterModalOpen(false);
  };

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Function to handle registration success
  const handleRegisterSuccess = () => {
    closeRegisterModal(); // Close the registration modal
    openLoginModal(); // Open the login modal
  };

  // Function to handle login success
  const handleLoginSuccess = () => {
    setIsLogin(true); // Update the login status
    localStorage.setItem("isLogin", "true"); // Save login status to localStorage
    closeLoginModal(); // Close the login modal
  };

  return (
    <nav className="flex flex-wrap justify-between items-center py-4 px-4 md:px-8 bg-white sticky w-full top-0 z-50 h-auto md:h-20 shadow-sm">
      <div className="flex items-center justify-end w-full md:w-auto">
        <button className="md:hidden text-2xl" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <IoClose /> : <RiMenu3Line />}
        </button>
      </div>

      {/* {isCompaniesPage && (
        <div className="w-full md:w-1/3 order-3 md:order-none mt-4 md:mt-0">
          <form onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search market statistics and insights"
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-black focus:outline-none"
            />
          </form>
        </div>
      )} */}

      <div
        className={`${
          isMobileMenuOpen ? "flex" : "hidden"
        } md:flex w-full md:w-auto flex-col md:flex-row justify-end items-center flex-grow order-2 md:order-none transition-all duration-300 ease-in-out`}
      >
        <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6 text-sm font-poppins w-full md:w-auto items-center mt-4 md:mt-0">
          <li>
            <Link
              to="/listing"
              className="font3 hover:text-black font-medium hover:underline block py-2 md:py-0"
            >
              Industries
            </Link>
          </li>
          <li>
            <Link
              to="/pricing"
              className="font3 hover:text-black font-medium hover:underline block py-2 md:py-0"
            >
              Pricing
            </Link>
          </li>
        </ul>

        {plans ? (
          <div className="relative flex flex-col md:flex-row items-center gap-5 font-poppins md:ml-5 w-full md:w-auto mt-4 md:mt-0">
            <button
              onClick={() => navigate("/manageplans")}
              className="hover:bg-black bg-[#263238] px-4 h-10 rounded-lg text-white w-full md:w-auto transition duration-300"
            >
              Upgrade Plan
            </button>
            <button
              ref={profileButtonRef}
              onClick={toggleProfileMenu}
              className="w-10 h-10 rounded-lg border7 flex items-center justify-center text-black border-black mt-4 md:mt-0 hover:bg-gray-100 transition duration-300"
            >
              <FaRegCircleUser className="w-6 h-6" />
            </button>
            {isProfileMenuOpen && (
              <div
                ref={profileMenuRef}
                className="absolute right-0 top-full mt-2 z-50"
              >
                <ProfileMenu />
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-col md:flex-row items-center gap-5 md:ml-5 font-poppins w-full md:w-auto mt-4 md:mt-0">
            <button
              onClick={openRegisterModal}
              className="border border-black px-4 py-2 rounded-lg hover:bg-black hover:text-white w-full md:w-auto transition duration-300"
            >
              Register
            </button>
            <button
              onClick={openLoginModal}
              className="bg-black border text-white px-5 py-2 rounded-lg hover:border-black hover:bg-white hover:text-black w-full md:w-auto mt-4 md:mt-0 transition duration-300"
            >
              Login
            </button>
          </div>
        )}
      </div>

      <RegisterModal
        isOpen={isRegisterModalOpen}
        closeModal={closeRegisterModal}
        onRegisterSuccess={handleRegisterSuccess}
      />
      <LoginModal
        isOpen={isLoginModalOpen}
        closeModal={closeLoginModal}
        onLoginSuccess={handleLoginSuccess} // Pass prop to handle login success
      />
    </nav>
  );
};

export default Navbar;
